/**
 * Storyblok utility functions
 * Helper functions to work with Storyblok data types
 */

import type { MultilinkStoryblok, AssetStoryblok } from '@/types';

/**
 * Extract URL string from MultilinkStoryblok object
 * @param link - Storyblok multilink object
 * @returns URL string
 */
export function getStoryblokLinkUrl(link: MultilinkStoryblok | undefined | null): string {
  if (!link) return '';

  // Use cached_url if available (most common case)
  if (link.cached_url) {
    return link.cached_url;
  }

  // Fallback to url field
  if (link.url) {
    return link.url;
  }

  // For email links
  if (link.linktype === 'email' && link.url) {
    return `mailto:${link.url}`;
  }

  return '';
}

/**
 * Extract filename/URL from AssetStoryblok object
 * @param asset - Storyblok asset object
 * @returns Asset URL string
 */
export function getStoryblokAssetUrl(asset: AssetStoryblok | undefined | null): string {
  if (!asset) return '';
  return asset.filename || '';
}

/**
 * Extract alt text from AssetStoryblok object with fallback
 * @param asset - Storyblok asset object
 * @param fallback - Fallback alt text
 * @returns Alt text string
 */
export function getStoryblokAssetAlt(asset: AssetStoryblok | undefined | null, fallback: string = ''): string {
  if (!asset) return fallback;
  return asset.alt || asset.title || fallback;
}
